import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PolicyTimeRangeColumn {
  key: string;
  label: string;
  type: 'text' | 'select' | 'duration';
  options?: string[];
}

@Component({
  selector: 'app-policy-time-range-table',
  templateUrl: './policy-time-range-table.component.html'
})
export class PolicyTimeRangeTableComponent {
  @Input() label = 'Time Ranges';
  @Input() helpText?: string;
  @Input() columns: PolicyTimeRangeColumn[] = [];
  @Input() rows: any[] = [];
  @Output() rowsChange = new EventEmitter<any[]>();

  addRow(): void {
    const row: any = {};
    for (const col of this.columns) {
      row[col.key] = col.type === 'select' ? (col.options?.[0] ?? '') : (col.type === 'duration' ? '00:00' : '');
    }
    this.rows = [...this.rows, row];
    this.rowsChange.emit(this.rows);
  }

  removeRow(index: number): void {
    this.rows = this.rows.filter((_, i) => i !== index);
    this.rowsChange.emit(this.rows);
  }

  emitChange(): void {
    this.rowsChange.emit(this.rows);
  }
}
